import { render, staticRenderFns } from "./power.vue?vue&type=template&id=f71c54e4&"
import script from "./power.vue?vue&type=script&lang=js&"
export * from "./power.vue?vue&type=script&lang=js&"
import style0 from "./power.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports